import * as actions from './customerPayment/actions'
import * as mutations from './customerPayment/mutations'
import * as getters from './customerPayment/getters'

import { dataProps } from './customerPayment/properties'

const state = {
    list: [],
    settlement_type: 1,
    nav: {
        page_number: 1, 
        had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1, 
        search_term: '', 
        search_term_array: []
    },
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/customerPayment.js